<div class="title" [innerHTML]="getTrustedHTML(value.title)"></div>

<div class="main" [innerHTML]="getTrustedHTML(value.description)"></div>